import {
  downloadZipExport,
  ExportValidationError,
} from "#modules/quoteRequests/infra/downloadZipExport";

export type ExportQuoteValidationError = ExportValidationError;

export const downloadExportQuote = async ({ quoteId }: { quoteId: string }): Promise<void> => {
  await downloadZipExport({
    url: `/quotes/${quoteId}/exports`,
    body: {},
    filename: `export-${quoteId}.zip`,
  });
};
